import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Helmet from 'react-helmet';
import DataFetcher from './DataFetcher';
import constantes from '../../resources/constantes.json';
import { snap } from '../../resources/constantes.json';
import GetStatsData from './GetStatsData';
import NotificationContainer from '../../components/Notification';
import { NotificationsProvider } from '../../contexts/notificationsContext';
import { PageProvider } from '../../contexts/pageContext';
import PageSwitch from './PageSwitch';
import { withRouter } from 'react-router-dom';
import { useNomenclator } from '../../contexts/nomenclatorContext';
import Inicio from '../../pages/Inicio';
import { EleccionProvider } from '../../contexts/eleccionContext';
import useIni from '../../hooks/useIni';
import SideBar from 'components/Sidebar';
import { SideBarPortalRenderer } from '../../components/Sidebar';
import TooltipMapa from '../../components/TooltipMapa';
import LogosProvider from '../../contexts/logosContext';
import ModalHistoricos from '../../containers/ModalHistoricos';

/**
 * Componente que se encarga de hacer fetch del nomenclator, que nos permite tener información
 * sobre todos los ámbitos y partidos que se presentan a las elecciones, y además nos permite
 * navegar por url en la aplicación.
 */

const levelFlag = {
  zona: 'z',
  comuna: 'c',
};

const getId = matchId => {
  const firstChar = matchId && matchId[0];
  let parentLevel;
  let id;
  switch (firstChar) {
    case levelFlag.zona:
      parentLevel = constantes.level.zona;
      id = Number(matchId.slice(1));
      break;
    case levelFlag.comuna:
      parentLevel = constantes.level.comuna;
      id = Number(matchId.slice(1));
      break;
    default:
      id = Number(matchId);
      break;
  }
  if (Number.isNaN(id)) {
    id = 0;
  }
  return { parentLevel, id };
};

const Enrutador = () => {
  const nomenclator = useNomenclator();
  const ini = useIni();
  return (
    <NotificationsProvider nomenclator={nomenclator}>
      <SideBar>
        <ModalHistoricos />
        <NotificationContainer />
        <Switch>
          <Route
            path="/(|inicio|index\.html)/:id?"
            render={() => (
              <PageProvider>
                <LogosProvider>
                  <EleccionProvider>
                    <SideBarPortalRenderer />
                    <Inicio nomenclator={nomenclator} />
                  </EleccionProvider>
                </LogosProvider>
              </PageProvider>
            )}
          />
          <Route
            path="/tooltip"
            render={() => {
              return (
                <PageProvider>
                  <LogosProvider>
                    <EleccionProvider>
                      <div
                        style={{
                          width: '100%',
                          height: '100vh',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          backgroundColor: '#f0bb8e',
                        }}
                      >
                        <TooltipMapa />
                      </div>
                    </EleccionProvider>
                  </LogosProvider>
                </PageProvider>
              );
            }}
          />
          <Route
            path="/(|estadisticas|index\.html)/:elec?"
            render={() =>
              ini?.isClosed ? <Redirect to="/inicio" /> : <CargarEstadisticas />
            }
          />
          <Route
            path="/"
            render={() =>
              ini?.isClosed ? (
                <Redirect to="/inicio" />
              ) : (
                <RutasConNomenclator />
              )
            }
          />
        </Switch>
      </SideBar>
    </NotificationsProvider>
  );
};

const CargarEstadisticas = withRouter(({ location }) => {
  const nomenclator = useNomenclator();
  if (nomenclator == null) return null;
  return (
    <PageProvider>
      <LogosProvider>
        <SideBarPortalRenderer />
        <Switch>
          <Route
            path="/estadisticas"
            render={() => <GetStatsData page="estadisticas" />}
          />
        </Switch>
        <PageSwitch />
      </LogosProvider>
    </PageProvider>
  );
});
const RutasConNomenclator = withRouter(({ location }) => {
  const nomenclator = useNomenclator();
  if (nomenclator == null) return null;

  return (
    <>
      <Helmet titleTemplate="%s | Elecciones Territoriales 2023" />
      <PageProvider>
        <LogosProvider>
          <EleccionProvider>
            <SideBarPortalRenderer />
            <Switch>
              <Route
                path="/(|inicio|index\.html)/:id?"
                render={({ location, history, match }) => {
                  const { id, parentLevel } = getId(match.params.id);
                  return (
                    <DataFetcher
                      page="inicio"
                      nomenclator={nomenclator}
                      pathname={location.pathname}
                      history={history}
                      eleccion={constantes.eleccion['inicio']}
                      id={id}
                      parentLevel={parentLevel}
                    />
                  );
                }}
              />
              <Route
                path="/historico/:idHistorico/(alcalde|gobernador|concejo|asamblea|jal)/:id?"
                render={({ location, history, match }) => {
                  const { id, parentLevel } = getId(match.params.id);
                  return (
                    <DataFetcher
                      page={match.params[0]}
                      nomenclator={nomenclator}
                      location={location}
                      history={history}
                      idHistorico={match.params.idHistorico}
                      eleccion={constantes.eleccion[match.params[0]]}
                      id={id}
                      parentLevel={parentLevel}
                    />
                  );
                }}
              />
              <Route
                path="/(alcalde|gobernador|concejo|asamblea|jal)/:id?"
                render={({ location, history, match }) => {
                  const { id, parentLevel } = getId(match.params.id);
                  return (
                    <DataFetcher
                      page={match.params[0]}
                      nomenclator={nomenclator}
                      pathname={location.pathname}
                      history={history}
                      idHistorico={undefined}
                      eleccion={constantes.eleccion[match.params[0]]}
                      id={id}
                      parentLevel={parentLevel}
                    />
                  );
                }}
              />
              <Route
                path="/estadisticas"
                render={() => <GetStatsData page="estadisticas" />}
              />
              <Route path="/" component={NotFoundRedirect} />
            </Switch>
            <PageSwitch />
          </EleccionProvider>
        </LogosProvider>
      </PageProvider>
    </>
  );
});

const NotFoundRedirect = () => {
  //TODO: necesitamos que en el servidor si van a esta ruta le pongan html response status 404 cuando devuelvan el html
  !snap && window.location.replace('https://registraduria.gov.co');
  return null;
};

export default Enrutador;
